import { EventEmitter } from "fbemitter";

export const EVENT_TOPICS = {
  ON_CATEGORY_DELETED: "OnCategoryDeleted",
  ON_EMPLOYEE_DELETED: "OnEmployeeDeleted",
  ON_EMPLOYEE_STATUS_UPDATED: "OnEmployeeStatusUpdated",
  ON_NEWS_DELETED: "OnNewsDeleted",
  ON_NEWS_SEQUENCE_CHANGED: "OnNewsSequenceChanged",
  ON_NEWS_UPDATED: "OnNewsUpdated",
  ON_PARTNER_DELETED: "OnPartnerDeleted",
  ON_PARTNER_UPDATED: "OnPartnerUpdated",
  ON_VACANCY_DELETED: "OnVacancyDeleted",
  ON_VACANCY_UPDATED: "OnVacancyUpdated",
  ON_STUDENT_DELETED: "OnStudentDeleted",
  ON_STUDENT_UPDATED: "OnStudentUpdated",
  ON_STUDENT_STATUS_UPDATED: "OnStudentStatusUpdated",
  ON_APPLICANT_DELETED: "OnApplicantDeleted",
  ON_APPLICANT_UPDATED: "OnApplicantUpdated",
};

export default new EventEmitter();
